/* ==========================================================================
   TechNest — quantity-input.js
   <tn-quantity> wraps a number input with accessible +/- buttons, clamps to the
   input's own min/max/step, and emits a `tn:quantity:change` event that the
   cart listens for. Without JavaScript the number input still works.
   ========================================================================== */
(function () {
  'use strict';

  const TN = window.TechNest || {};
  const utils = TN.utils;
  if (!utils) return;

  class TnQuantity extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="number"]');
      if (!this.input) return;
      this.decrease = this.querySelector('[data-tn-qty-down]');
      this.increase = this.querySelector('[data-tn-qty-up]');

      if (this.decrease) this.decrease.addEventListener('click', () => this.step(-1));
      if (this.increase) this.increase.addEventListener('click', () => this.step(1));

      this.input.addEventListener('change', () => this.commit());
      // Enter inside a cart line should apply, not submit the enclosing form.
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.commit();
        }
      });
      this.syncButtons();
    }

    get min() {
      const v = parseInt(this.input.min, 10);
      return isNaN(v) ? 0 : v;
    }
    get max() {
      const v = parseInt(this.input.max, 10);
      return isNaN(v) ? Infinity : v;
    }
    get stepSize() {
      const v = parseInt(this.input.step, 10);
      return isNaN(v) || v < 1 ? 1 : v;
    }
    get value() {
      const v = parseInt(this.input.value, 10);
      return isNaN(v) ? this.min : v;
    }

    step(direction) {
      this.setValue(this.value + direction * this.stepSize);
      this.commit();
    }

    setValue(next) {
      const clamped = Math.min(this.max, Math.max(this.min, next));
      this.input.value = String(clamped);
      this.syncButtons();
      return clamped;
    }

    /** Normalise whatever the shopper typed, then notify listeners. */
    commit() {
      const before = this.input.value;
      const after = this.setValue(this.value);
      if (this.max !== Infinity && parseInt(before, 10) > this.max) {
        utils.toast(
          utils.format(TN.strings.quantityError || '', { qty: this.max }),
          'error'
        );
      }
      this.dispatchEvent(
        new CustomEvent('tn:quantity:change', {
          bubbles: true,
          detail: { value: after, line: this.dataset.line, key: this.dataset.key }
        })
      );
    }

    syncButtons() {
      if (this.decrease) this.decrease.disabled = this.value <= this.min;
      if (this.increase) this.increase.disabled = this.value >= this.max;
    }
  }

  utils.define('tn-quantity', TnQuantity);
})();
